import { Component, Input, OnChanges, SimpleChange } from '@angular/core';

@Component({
  selector: 'app-custom-loader',
  templateUrl: './custom-loader.component.html',
  styleUrls: ['./custom-loader.component.css']
})
export class CustomLoaderComponent implements OnChanges {
  @Input() showLoader: boolean
  activeClass: string = ''
  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {

    for (let propName in changes) {
      let changedProp = changes[propName];
      this.showLoader = changedProp.currentValue
    }
    this.activeClass = ''
    if (this.showLoader) {
      this.activeClass = 'active'
    }


  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-master/custom-loader/custom-loader.component.ts